import { IApplicationState } from '../../types/redux';

export const selectShowRatingInfoModal = (state: IApplicationState) => {
  return state.modals.ratingInfoModal.show;
};

export const selectRatingInfoModalModerationUrl = (state: IApplicationState) => {
  return state.modals.ratingInfoModal.moderationRulesUrl;
};
